import "./App.css";
import { Login2 } from "./components/pages/Frontend/user_auth/login/Login2";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import "./assets/styles/global-style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-quill/dist/quill.snow.css";
import PublicLayout from "./components/defaultStructure/PublicLayout";
import AdminLayout from "./components/defaultStructure/AdminLayout";
import { ChakraProvider } from "@chakra-ui/react";
import Login from "./components/pages/Frontend/user_auth/login/Login";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerList } from "./components/redux/utilsReduxApi/getCustomerList";
import { getCollectionList } from "./components/redux/utilsReduxApi/getCollectionList";
import { ToastContainer } from "react-toastify";
import './components/redux/api/axiosInterceptor/axiosGlobalInterceptor'
import { lazy, useCallback, useEffect, useState } from "react";


// Public / shared layouts & pages
import Wishlist from "./components/pages/Frontend/MyAccount/components/Wishlist";
import Orders from "./components/pages/Frontend/MyAccount/components/Orders";
import MyAccountLayout from "./components/defaultStructure/MyAccountLayout";
import AccountDashboard from "./components/pages/Frontend/MyAccount/AccountDashboard";
import ViewOrder from "./components/pages/Frontend/MyAccount/components/ViewOrder";
import Addresses from "./components/pages/Frontend/MyAccount/components/Addresses";
import BillingAddress from "./components/pages/Frontend/MyAccount/components/BillingAddress";
import ShippingAddress from "./components/pages/Frontend/MyAccount/components/ShippingAddress";
import CustomerAccountForm from "./components/pages/Frontend/MyAccount/components/CustomerAccountForm";
import ForgetPassword from "./components/pages/Frontend/user_auth/login/Forgotpass";
import ScrollTop from "./components/pages/Frontend/ScrollTop";

import { Toaster } from "react-hot-toast";
import AdminSingIn from "./components/pages/Frontend/user_auth/signup/AdminSingIn";

import { cartProductCount, getCartProducts } from "./components/redux/reduxApi/website/CartProductCount";
import { getWishlistCount } from "./components/redux/reduxApi/website/WishlistApi";

import { setGuestCartCount } from "./components/redux/reduxSlice/website/CartSlice";

import AdminRoutes from "./routes/AdminRoutes";



const isAuthenticated = () => localStorage.getItem("role") !== null;
const getRole = () => localStorage.getItem("role");

/** Same session signals Navbar uses: Catalyst profile JSON, Login2 token, or customer ROWID. */
const hasStorefrontAccountSession = () => {
  if (localStorage.getItem("catalystUser")) return true;
  if (localStorage.getItem("authToken")) return true;
  const customerId = localStorage.getItem("customerId");
  return !!(customerId && String(customerId).trim() !== "");
};

function App() {
  const dispatch = useDispatch();
  const AdminData = useSelector((state) => state.AdminSingIn.AdminSingIn || " ");
  const login = useSelector((state) => state.Login || " ");

  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  // const catalystUser=localStorage.getItem("catalystUser");
  // console.log("catalystUser in app.js ", catalystUser);
  const dispatchCartAndWishlistCounts = useCallback(() => {
    const userRowId = localStorage.getItem("customerId");
    if (!userRowId || String(userRowId).trim() === "") return;
    dispatch(cartProductCount());
    dispatch(getWishlistCount());
  }, [dispatch]);

  useEffect(() => {
    if (authToken) {
      dispatchCartAndWishlistCounts();
    }
  }, [authToken, dispatchCartAndWishlistCounts]);

  useEffect(() => {
    const onAppUserLoggedIn = () => {
      setAuthToken(localStorage.getItem("authToken"));
      dispatchCartAndWishlistCounts();
    };
    window.addEventListener("appUserLoggedIn", onAppUserLoggedIn);
    return () => window.removeEventListener("appUserLoggedIn", onAppUserLoggedIn);
  }, [dispatchCartAndWishlistCounts]);

  useEffect(() => {
    // dispatch(getCustomerList());
    // dispatch(getCollectionList());
    // dispatch(getProductList());
    // dispatch(getTages());
    // dispatch(getCartProducts());
    // dispatch(cartProductCount());
    // dispatch(getWishlistCount());
    // const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
    // dispatch(setGuestCartCount(guestCart.length));
  }, []);
  
  useEffect(() => {
    const handleStorageChange = () => {
      setAuthToken(localStorage.getItem("authToken"));
    };
    const handleAuthChange = () => {
      setAuthToken(localStorage.getItem("authToken"));
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("authChange", handleAuthChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("authChange", handleAuthChange);
    };
  }, []);


  return (
    <>
      <ToastContainer position="top-left" autoClose={2500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />

      <ChakraProvider>
        <HashRouter future={{ v7_startTransition: true }}>
          <ScrollTop />
          <Routes>


              {/* Public Layout */}
              <Route path="/*" element={<PublicLayout />} />
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/login" element={<Login2 />} />
            <Route path="/forgot-password" element={<ForgetPassword />} />
            <Route path="/login/admin" element={<AdminSingIn />} />

            {/* Admin Layout */}
            <Route
              path="/admin/*"
              element={AdminData?.authToken ? <AdminLayout /> : <Navigate to="/login/admin" replace />}
            >
             {AdminRoutes()}
            </Route>


            {/* My Account Layout */}
            <Route
              path="/account/*"
              element={hasStorefrontAccountSession() ? <MyAccountLayout /> : <Navigate to="/login" replace />}
            >
              <Route path="dashboard" element={<AccountDashboard />} />
              <Route path="wishlist" element={<Wishlist />} />
              <Route path="orders" element={<Orders />} />
              <Route path="view-order/:id" element={<ViewOrder />} />
              <Route path="edit-address" element={<Addresses />} />
              <Route path="billing" element={<BillingAddress />} />
              <Route path="shipping" element={<ShippingAddress />} />
              <Route path="edit-account" element={<CustomerAccountForm />} />
              {/* <Route path="/shop" element={<Shop />} /> */}
              {/* <Route path="/shop/:productId" element={<ProductDetails />} /> */}
            </Route>
          </Routes>
        </HashRouter>
        <Toaster position="top-center" />
      </ChakraProvider>
    </>
  );
}

export default App;
